import React from 'react';
import { DropdownOptions } from '../../constants/DropdownOptions';

const Dropdown = props => {
    const {
        widthProportion,
        fixedWidth,
        label,
        labelMobileOnly,
        options,
        optionsType,
        name,
        blankOption,
        blankOptionLabel,
        register,
        ...rest
    } = props;
    const widthProp = widthProportion ? widthProportion : 'full';

    let style = {};
    if (fixedWidth) {
        style = {
            width: fixedWidth,
        };
    }

    const renderLabel = () => {
        if (!label) {
            return '';
        }

        if (labelMobileOnly) {
            return <div className="app__dropdown__label--mobile">{label}</div>;
        }

        return <div className="app__dropdown__label">{label}</div>;
    };

    const renderOptions = () => {
        const optionsElements = [];
        let listOfOptions = options;

        if (!listOfOptions && !optionsType) {
            listOfOptions = DropdownOptions.get(name);
        } else if (optionsType) {
            listOfOptions = DropdownOptions.get(optionsType);
        }

        if (!listOfOptions || !listOfOptions.length) {
            return '';
        }

        if (blankOption) {
            const defaultBlankOptionLabel = label ? label.toLowerCase() : 'an option';
            const blankOptionlbl = blankOptionLabel ? blankOptionLabel : defaultBlankOptionLabel;

            optionsElements.push(<option value="">-- select {blankOptionlbl} --</option>);
        }

        for (let i = 0; i < listOfOptions.length; i++) {
            const option = listOfOptions[i];
            optionsElements.push(
                <option key={i} value={option.value}>
                    {option.text}
                </option>
            );
        }
        return optionsElements;
    };

    return (
        <div className="app__dropdown">
            {renderLabel()}
            <select
                className={`app__dropdown__dropdown ${widthProp}`}
                name={name}
                style={style}
                {...register}
                {...rest}>
                {renderOptions()}
            </select>
        </div>
    );
};

export default Dropdown;
